module.exports = __webpack_public_path__ + "static/img/award3.4094abb.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/index/award3.png
// module id = RibV
// module chunks = 7